import { UserType } from '../models/user';

export const newUserTypes = [
  {
    id: UserType.Particulier,
    txt: 'Particulier',
    fileName: 'user-particulier'
  },
  {
    id: UserType.Agence,
    txt: 'Agence',
    fileName: 'user-agence'
  },
  {
    id: UserType.Notaire,
    txt: 'Notaire',
    fileName: 'user-notaire'
  },
  {
    id: UserType.Installateur,
    txt: 'Installateur',
    fileName: 'user-installateur'
  }
];

export const userTypePartAndPro = [
  {
    id: -1,
    txt: 'Sélectionnez un type de client',
    fileName: 'user-type'
  },
  {
    id: 0,
    txt: 'Particulier',
    fileName: 'user-particulier'
  },
  {
    id: 1,
    txt: 'Pro',
    fileName: 'user-professionnel'
  }
];
